@if (data?.certificate; as certificate) {
  <div class="certificate-modal">
    <div class="certificate-modal__header">
      <button mat-icon-button class="button button--icon button--transparent" (click)="dialogRef.close()">
        <lib-icon icon="x"></lib-icon>
      </button>
    </div>
    <div class="certificate-modal__body">
      <div
        class="certificate-modal__body--image"
        [cropImage]="certificate?.customCertificate?.mediaImage | preSignedUrl | async"
        [additionalOptions]="{width: 400}">
      </div>
      <div class="certificate-modal__body--title-wrapper">
        <div class="certificate-modal__body--title">
          {{certificate.title}}
        </div>
        @if (certificate.dateOfCompletion) {
          <div class="certificate-modal__body--subtitle">
            {{'COMMON.granted' | translate}} {{certificate.dateOfCompletion | customDate}}
          </div>
        }
      </div>
    </div>
    <div class="certificate-modal__footer">
      @if (data.shareEnabled) {
        <button mat-icon-button class="button button--icon button--transparent" (click)="share()">
          <lib-icon icon="share-network"></lib-icon>
        </button>
      }
      <button mat-icon-button class="button button--icon button--transparent" [ngClass]="{'d-none d-lg-block': !data.shareEnabled}" (click)="preview()">
        <lib-icon  icon="eye"></lib-icon>
      </button>
      <div class="certificate-modal__footer-button-wrapper">
        <button mat-flat-button class="button button--primary button--large preview-button" (click)="download()">
          @if (!isDownloading) {
            <lib-icon icon="download-simple"></lib-icon>
          } @else {
            <mat-spinner class="secondary-progress-spinner-color" diameter="24"></mat-spinner>
          }
          {{'COMMON.download' | translate}}
        </button>
        @if (!data.shareEnabled) {
          <button mat-flat-button class="button button--primary button--large preview-button d-lg-none" (click)="preview()">
            <lib-icon icon="eye"></lib-icon>
            {{'COMMON.preview' | translate}}
          </button>
        }
      </div>
    </div>
  </div>
}
